'use strict';

define('features/ctas/offers.cta',[
  'jquery',
  'lib/util/tda.config',
  './cta.types',
  './www'
], function (
  $,
  tdaConfig,
  ctaTypes,
  wwwClickEvent
) {
  var __type = ctaTypes['offers']; // eslint-disable-line dot-notation
  var __defaultUrl = '/' + tdaConfig.site.context_url + '/offers/';
  var __isWWW = tdaConfig.tda.code === 'WWW';

  // TODO: only tested in offer-details-ajax. Will likely need more cleaning
  function __cleanSeries(series) {
    var cleaned = series.split(' ')[0];
    return cleaned;
  }

  return function offers(series, $scope) {
    var $ctaScope = $scope || $('body');
    var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);

    if (!$ctas.length) return;
    if (!series) {
      $ctas.each(function () {
        var $this = $(this);
        $this.attr('href', __defaultUrl);
        if (__isWWW) {
          wwwClickEvent($this);
        }
      });
      return;
    }

    $ctas.each(function () {
      var $this = $(this);
      $this.attr('href', __defaultUrl + __cleanSeries(series));
      if (__isWWW) {
        wwwClickEvent($this);
      }
    });
  };
});

